import React from 'react';
import PropTypes from 'prop-types';
import { OutlineButton } from '../../@communityshare/ui/Button';
import { SolidButton } from '../../@communityshare/ui/Button';
import StringField from '../../forms/_fields_v2/StringField';
import TextAreaField from '../../forms/_fields_v2/TextAreaField';
import FormTemplate from '../../dialogs_common/FormTemplate';
import FormField from '../../forms/_common/FormField';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';
import SelectField from '../../forms/_fields_v2/SelectField';

Form.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};

Form.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function Form(props) {
  const {
    data,
    errors,
    showErrors,
    alert,
    onChange,
    onSubmit,
    onClose
  } = props;

  function sectionTitle(title, description) {
    return (
      <div>
        <div className="text-lg font-semibold text-cs-gray-700">
          {title}
        </div>
        <div>
          {description}
        </div>
      </div>
    );
  }

  return (
    <FormTemplate
      title="Edit support question"
      subtitle="Fill out the information below to make changes to the support question."
      onClose={onClose}
      alert={alert}
      body={(
        <div className="space-y-8">
          <div className="space-y-4">
            <FormField name="question" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <TextAreaField
                  label="Question*"
                  placeholder="Question..."
                  rows={2}
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
            <FormField name="order" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => {
                return (
                  <SelectField
                    label="Order"
                    description="Questions with lower numbers are displayed first."
                    value={`${field.value}`}
                    error={field.error}
                    placeholder="Select a number..."
                    options={{
                      data: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(function(value) {
                        return {
                          id: `${value}`,
                          data: {
                            name: `${value}`
                          }
                        };
                      })
                    }}
                    optionLabel="name"
                    onChange={function(result) {
                      field.onChange(Number(result));
                    }}
                  />
                )
              }}
            </FormField>
          </div>
          <div className="space-y-4">
            {sectionTitle(
              `Audience*`,
              `Who is this question intended for?`
            )}
            <FormField name="audience" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <SelectField
                  // label="Audience"
                  // description="Who is this question intended for?"
                  value={field.value}
                  error={field.error}
                  placeholder="Select a profile type..."
                  options={{
                    data: ['Educator', 'Partner'].map(function(value) {
                      return {
                        id: value,
                        data: {
                          name: value
                        }
                      };
                    })
                  }}
                  optionLabel="name"
                  onChange={field.onChange}
                />
              )}
            </FormField>
          </div>
          <div className="space-y-4">
            {sectionTitle(
              `Resource Details`,
              `Information about the resource users can reference for self-help.`
            )}
            <FormField name="resourceTitle" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <StringField
                  label="Resource Title"
                  placeholder="Title..."
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
            <FormField name="resourceDescription" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <TextAreaField
                  label="Resource Description"
                  placeholder="Description..."
                  rows={4}
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
            <FormField name="resourceUrl" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <StringField
                  label="Resource URL"
                  placeholder="https://..."
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
          </div>
          <div className="space-y-4">
            {sectionTitle(
              `Staff Details`,
              `Information about the staff member who should be listed as a support contact.`
            )}
            <FormField name="staffName" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <StringField
                  label="Staff Name"
                  placeholder="Name..."
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
            <FormField name="staffDescription" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <StringField
                  label="Staff Description"
                  placeholder="Description..."
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
            <FormField name="staffSchedulingUrl" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <StringField
                  label="Staff Scheduling URL"
                  placeholder="https://..."
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
            <FormField name="staffEmail" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <StringField
                  label="Staff Email"
                  placeholder="Email..."
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
            <FormField name="staffAvatarUrl" data={data} errors={showErrors && errors} onChange={onChange}>
              {(field) => (
                <StringField
                  label="Staff Avatar URL"
                  placeholder="URL..."
                  // description="Some text about a thing I like"
                  value={field.value}
                  error={field.error}
                  onChange={field.onChange}
                />
              )}
            </FormField>
          </div>
        </div>
      )}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onClose}>
            Cancel
          </OutlineButton>
          <SolidButton onClick={onSubmit}>
            Update support question
          </SolidButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
